import React, { FC, useMemo } from 'react';
import { Breadcrumbs, Theme, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { RETAIL_COMPARE_ENERGY_RATES_FULL_ROUTE } from 'config/retail/routes';
import { CustomerType } from 'services/orders/types';
import { useRouter } from 'next/router';
import { PageLink } from "components/common/atoms";

interface RetailBreadcrumbsProps {
  customerType: CustomerType;
}

const StyledBreadcrumbs = withStyles((theme: Theme) => ({
  root: {
    marginTop: 85,
    marginBottom: 10,
    [theme.breakpoints.up('sm')]: {
      marginTop: 120,
      marginBottom: 30,
    },
    '& a': {
      fontWeight: 600,
      fontSize: 14,
      color: '#93979B',
    },
    '& p': {
      fontWeight: 600,
      fontSize: 14,
      color: '#000',
    },
  },
}))(Breadcrumbs);

const createItems = (customerType: CustomerType, zipCode) => {
  return [
    { url: '/', label: 'Energy5' },
    {
      url: RETAIL_COMPARE_ENERGY_RATES_FULL_ROUTE(customerType, zipCode),
      label: 'Retail Energy',
    },
    { label: 'Plans' },
  ];
};

const RetailBreadcrumbs: FC<RetailBreadcrumbsProps> = (props) => {
  const { customerType } = props;
  const {
    query: { zipCode },
  } = useRouter();
  const items = useMemo(() => createItems(customerType, zipCode), [customerType, zipCode]);

  return (
    <StyledBreadcrumbs>
      {items.map(({ url, label }) =>
        url ? (
          <PageLink href={url} key={label}>{label}</PageLink>
        ) : (
          <Typography color="textPrimary" key={label}>
            {label}
          </Typography>
        )
      )}
    </StyledBreadcrumbs>
  );
};

export default RetailBreadcrumbs;
